import getLogger from '../util/logger';

const log = getLogger('PhotoUploadAction');

export const PHOTO_UPLOAD_SUCCESS = 'photo/UPLOAD_SUCCESS';
export const PHOTO_UPLOAD_REMOVE = 'photo/UPLOAD_REMOVE';

const photoUploadSuccessAction = photo => {
  return { type: PHOTO_UPLOAD_SUCCESS, photo };
};

export const photoUploadRemoveAction = photoId => {
  return { type: PHOTO_UPLOAD_REMOVE, photoId };
};

export const photoUploadSuccess = (photo, createUrl) => async dispatch => {
  if (!createUrl || !window.FileReader) {
    log.info('photoUploadSuccess() :: Uploaded photo', photo);

    dispatch(photoUploadSuccessAction(photo));
    return;
  }

  const fileUrl = URL.createObjectURL(photo.file);

  dispatch(
    photoUploadSuccessAction({
      ...photo,
      id: photo.id,
      url: fileUrl,
    }),
  );
};
